export default "__VITE_ASSET__C5HZg6Il__"